import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CompanyComponent } from './company/company.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  // {
  //   path:'login',
  //   component:LoginComponent
  // },
  // {
  //   path:'signup',
  //   component:SignupComponent
  // },
  // {
  //   path:'profile',
  //   component:ProfileComponent
  // },{
  //   path:'dashboard',
  //   component:DashboardComponent
  // },{
  //   path:'company',
  //   component:CompanyComponent
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules ,useHash:true})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
